import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-gdpr',
  templateUrl: './app-gdpr.component.html',
  styleUrls: ['./app-gdpr.component.css']
})
export class AppGdprComponent implements OnInit{

  @Input() gdprStatus: string;
  @Output() closeGDPR = new EventEmitter<any>();

  assetsRoute: string = "../../assets";

  buttonTheme: any = {
    'position':'inherit',
    'fontSize': 'fontSize15',
    'buttonElem':[
      {
        'color': 'blue',
        'text': '个人信息处理请求表',
        'className': 'inlineBlockRadiusBtn width-70 margin-auto'
      }
    ]

  }; //按钮主题

  constructor(
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
  }

  close(){
    this.closeGDPR.emit();
  }

  submit(){
    window.open('https://ddi.jinshuju.com/f/fMkeNV');
  }

}



// WEBPACK FOOTER //
// ./src/app/app-gdpr/app-gdpr.component.ts